import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';
import useGrillData from './useGrillData';

const GrillSize = ({
    value,
    onChange,
    id = 'GrillSize',
    label = 'Grill Size',
    disabled = false,
    showPics = false,
    grillTypeValue = null  // Filter sizes by grill type value
}) => {
    const [selectedGrillSize, setSelectedGrillSize] = useState(value || '');
    const [showModal, setShowModal] = useState(false);
    const { getGrillSizes, getGrillTypeId, loading, error } = useGrillData();

    // Get grill type ID from value if provided
    const grillTypeId = grillTypeValue ? getGrillTypeId(grillTypeValue) : undefined;
    const grillSizes = getGrillSizes(grillTypeId);

    // Update selected value when grillTypeValue changes or options change
    useEffect(() => {
        if (!loading && grillSizes.length > 0) {
            // Check if current selection is still valid
            const isValidSelection = grillSizes.some(s => s.value === selectedGrillSize);
            if (!isValidSelection) {
                const defaultValue = grillSizes[0]?.value || '';
                setSelectedGrillSize(defaultValue);
                onChange(defaultValue);
            }
        }
    }, [loading, grillTypeId, grillTypeValue, selectedGrillSize, onChange]);

    const handleGrillSizeChange = (e) => {
        setSelectedGrillSize(e.target.value);
        onChange(e.target.value);
    };

    if (error) {
        console.error('Error loading grill sizes:', error);
    }

    return (
        <div className="a-container">
            <label
                disabled={disabled}
                htmlFor={id}
                onClick={() => showPics && setShowModal(true)}
                style={{ cursor: showPics ? 'pointer' : 'default' }}
            >
                {label}
            </label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedGrillSize}
                onChange={handleGrillSizeChange}
            >
                {loading ? (
                    <option value="">Loading...</option>
                ) : (
                    grillSizes.map(option => (
                        <option key={option.id} value={option.value}>
                            {selectedGrillSize === option.value ? `${option.label} ✔` : option.label}
                        </option>
                    ))
                )}
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/GrillSize"
                imageName={selectedGrillSize}
                width={200}
                height={250}
            />
        </div>
    );
};

export default GrillSize;
